import { padStart } from 'lodash-es';
import TransformError from './error';
import { getBytes } from './utils';

function* subStrMyGenerator(dpValue: string): Iterator<string, string, number> {
  let start = 0;
  let result = '';
  let length;
  for (; true; ) {
    length = (yield result) * 2;
    result = dpValue.substr(start, length);
    if (start + length >= dpValue.length) {
      break;
    }
    start += length;
  }
  return result;
}

/**
 * 截取字符串
 * @param dpValue
 * @returns
 */
export const createMyGenerator = (dpValue: string): MyGenerator => {
  const ganerator = subStrMyGenerator(dpValue);
  ganerator.next();
  let isEnd = dpValue.length === 0; // 修复无值时返回错误数据

  // 截取数据
  const next = (config: DpMapItem, result: any): string => {
    if (isEnd) {
      // 结束抛出错误
      throw new TransformError(TransformError.ALLREADY_TO_END, '已经解析到末尾，无法再解析');
    }
    const { storageType = 'be' } = config;
    const bytes = getBytes(config, result);
    const { value, done } = ganerator.next(bytes);
    isEnd = done;
    if (storageType === 'le') {
      // 小端格式
      const result: string[] = [];
      for (let i = 0; i < value.length; i += 2) {
        result.splice(0, 0, value.slice(i, i + 2));
      }
      return result.join('');
    }
    return value;
  };

  const nextBits = (config: DpMapItem, res: any) => {
    const { numType = 'hex', bitType = 'right' } = config;
    const value = next(config, res);
    const radix = numType === 'dec' ? 10 : 16;
    const result: Array<1 | 0> = [];
    for (let i = 0; i < value.length; i += 2) {
      const temp = parseInt(value.slice(i, i + 2), radix);
      const bits = padStart(temp.toString(2), 8, '0')
        .split('')
        .map(v => Number(v)) as Array<1 | 0>;
      // 是否为从右边取数据
      if (bitType === 'right') {
        bits.reverse();
      }
      result.push(...bits);
    }
    return result;
  };

  // 截取数据并转化为一个十进制
  const nextNumber = (config: DpMapItem, result: any) => {
    const { numType = 'hex' } = config;
    return parseInt(next(config, result), numType === 'dec' ? 10 : 16);
  };
  // 截取数据并转化为一个布尔值
  const nextBoolean = (config: DpMapItem, result: any) => {
    return Boolean(nextNumber(config, result));
  };

  const hasNext = () => {
    return !isEnd;
  };
  return {
    next,
    nextNumber,
    nextBoolean,
    nextBits,
    hasNext,
  };
};
